// src/theme/index.js
export const colors = {
  primary:   { 50:'#E3F2FD', 100:'#BBDEFB', 200:'#90CAF9', 500:'#2196F3', 600:'#1E88E5', 700:'#1976D2', 800:'#1565C0', 900:'#0D47A1' },
  success:   { 50:'#E8F5E9', 100:'#C8E6C9', 500:'#4CAF50', 600:'#43A047', 700:'#388E3C' },
  warning:   { 50:'#FFF8E1', 100:'#FFECB3', 500:'#FFC107', 600:'#FFB300', 700:'#FFA000' },
  error:     { 50:'#FFEBEE', 100:'#FFCDD2', 500:'#F44336', 600:'#E53935', 700:'#D32F2F' },
  neutral:   { 50:'#FAFAFA', 100:'#F5F5F5', 200:'#EEEEEE', 300:'#E0E0E0', 400:'#BDBDBD', 500:'#9E9E9E', 600:'#757575', 700:'#616161', 800:'#424242', 900:'#212121' },
  score: { excellent:'#388E3C', good:'#689F38', average:'#FFA000', poor:'#D32F2F' },
  status: { FC:'#388E3C', PC:'#FFA000', NC:'#D32F2F', NA:'#757575' },
  background: '#F4F6F9',
  surface:    '#FFFFFF',
  divider:    '#E0E0E0',
  text: { primary:'#212121', secondary:'#616161', disabled:'#9E9E9E', inverse:'#FFFFFF' },
  white: '#FFFFFF',
};

export const KAYAKALP_PASS_SCORE = 70;

export const KK_THEMES = [
  { id:1, code:'A', label:'Hospital Upkeep' },
  { id:2, code:'B', label:'Sanitation & Hygiene' },
  { id:3, code:'C', label:'Support Services' },
  { id:4, code:'D', label:'Infection Control' },
  { id:5, code:'E', label:'Waste Management' },
  { id:6, code:'F', label:'Patient Care' },
  { id:7, code:'G', label:'Supportive Management' },
  { id:8, code:'H', label:'Hygiene Promotion' },
];

export function getScoreColor(pct) {
  if (pct >= 90) return colors.score.excellent;
  if (pct >= 75) return colors.score.good;
  if (pct >= 50) return colors.score.average;
  return colors.score.poor;
}

export function getScoreBand(pct) {
  if (pct >= 90) return 'Excellent';
  if (pct >= 75) return 'Good';
  if (pct >= 50) return 'Average';
  return 'Poor';
}
